"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function LatticeGrid(_ref) {
  var children = _ref.children,
      className = _ref.className,
      fullGrid = _ref.fullGrid,
      fullWidth = _ref.fullWidth,
      innerGrid = _ref.innerGrid,
      fullLeft = _ref.fullLeft,
      fullRight = _ref.fullRight,
      overlay = _ref.overlay,
      useGutters = _ref.useGutters,
      tag = _ref.tag,
      style = _ref.style,
      forwardRef = _ref.forwardRef,
      onAnimationStart = _ref.onAnimationStart,
      onAnimationEnd = _ref.onAnimationEnd,
      onClick = _ref.onClick,
      onKeyPress = _ref.onKeyPress,
      onTouchStart = _ref.onTouchStart,
      onMouseDown = _ref.onMouseDown,
      title = _ref.title,
      id = _ref.id,
      role = _ref.role;
  var outerGridClasses = ["ltc__el"];
  var innerGridClasses = ["ltc__g"];
  var Tag = tag;
  outerGridClasses.push(fullWidth ? "ltc__el--f" : "ltc__el--m");

  if (fullLeft) {
    outerGridClasses.push("ltc__el--fl");
  } else if (fullRight) {
    outerGridClasses.push("ltc__el--fr");
  }

  if (overlay) {
    outerGridClasses.push("ltc__el--o");
  }

  if (useGutters) {
    outerGridClasses.push("ltc__el--gut");
  }

  if (innerGrid) {
    innerGridClasses.push(fullGrid ? "ltc__g--f" : "ltc__g--m");
  }

  if (className) {
    outerGridClasses = outerGridClasses.concat(Array.isArray(className) ? className : className.split(" "));
    innerGridClasses = innerGridClasses.concat(Array.isArray(className) ? className.map(function (c) {
      return c + "__grid";
    }) : className.split(" ").map(function (c) {
      return c + "__grid";
    }));
  }

  return /*#__PURE__*/_react.default.createElement(Tag, {
    className: outerGridClasses.join(" "),
    id: id,
    ref: forwardRef,
    onAnimationStart: onAnimationStart,
    onAnimationEnd: onAnimationEnd,
    onClick: onClick,
    onKeyPress: onKeyPress,
    onTouchStart: onTouchStart,
    onMouseDown: onMouseDown,
    title: title,
    style: style,
    role: role
  }, innerGrid ? /*#__PURE__*/_react.default.createElement("div", {
    className: innerGridClasses.join(" ")
  }, children) : children);
}

LatticeGrid.designSystemProps = {
  children: {
    type: "node",
    description: "Grid content.",
    propType: _propTypes.default.node,
    default: null,
    required: false
  },
  className: {
    type: ["string", "array"],
    description: "List of classes for this element.",
    required: false,
    propType: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
    default: ""
  },
  fullGrid: {
    type: "boolean",
    description: "Uses full width inner grid if true.",
    propType: _propTypes.default.bool,
    default: false,
    required: false
  },
  fullWidth: {
    type: "boolean",
    description: "Uses full width grid wrapper if true.",
    propType: _propTypes.default.bool,
    default: false,
    required: false
  },
  innerGrid: {
    type: "boolean",
    description: "Uses inner grid if true.",
    propType: _propTypes.default.bool,
    default: false,
    required: false
  },
  fullLeft: {
    type: "boolean",
    description: "Starts grid at the left of the screen if true.",
    propType: _propTypes.default.bool,
    default: false,
    required: false
  },
  fullRight: {
    type: "boolean",
    description: "Ends grid at the right of the screen if true.",
    propType: _propTypes.default.bool,
    default: false,
    required: false
  },
  overlay: {
    type: "boolean",
    description: "Displays full screen overlay if true.",
    propType: _propTypes.default.bool,
    default: false,
    required: false
  },
  useGutters: {
    type: "boolean",
    description: "Uses gutters as grid columns if true.",
    propType: _propTypes.default.bool,
    default: false,
    required: false
  },
  tag: {
    type: "string",
    description: "HTML element to use for grid.",
    propType: _propTypes.default.string,
    default: "div",
    required: false
  },
  style: {
    type: "object",
    description: "Styles defined for grid.",
    propType: _propTypes.default.objectOf(_propTypes.default.string),
    default: {},
    required: false
  },
  forwardRef: {
    type: ["function", "object"],
    description: "Ref to component or DOM element.",
    subProps: {
      current: {
        type: ["any"],
        description: "DOM node of Ref object",
        required: false,
        default: null
      }
    },
    required: false,
    default: null,
    propType: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
      current: _propTypes.default.any
    })])
  },
  onAnimationStart: {
    type: "function",
    description: "Handler for animation start event.",
    propType: _propTypes.default.func,
    default: null,
    required: false
  },
  onAnimationEnd: {
    type: "function",
    description: "Handler for animation end event.",
    propType: _propTypes.default.func,
    default: null,
    required: false
  },
  onClick: {
    type: "function",
    description: "Handler for click event.",
    propType: _propTypes.default.func,
    default: null,
    required: false
  },
  onKeyPress: {
    type: "function",
    description: "Handler for key press event.",
    propType: _propTypes.default.func,
    default: null,
    required: false
  },
  onTouchStart: {
    type: "function",
    description: "Handler for touch start event.",
    propType: _propTypes.default.func,
    default: null,
    required: false
  },
  onMouseDown: {
    type: "function",
    description: "Handler for mouse down event.",
    propType: _propTypes.default.func,
    default: null,
    required: false
  },
  title: {
    type: "string",
    description: "Accessibility title for grid.",
    propType: _propTypes.default.string,
    default: null,
    required: false
  },
  id: {
    type: "string",
    description: "Unique identifier for grid.",
    propType: _propTypes.default.string,
    default: null,
    required: false
  },
  role: {
    type: "string",
    description: "Accessibility role for grid.",
    propType: _propTypes.default.string,
    default: null,
    required: false
  }
};
var propTypes = {};
var defaultProps = {};
Object.entries(LatticeGrid.designSystemProps).map(function (_ref2) {
  var k = _ref2[0],
      v = _ref2[1];

  if (v.propType) {
    propTypes[k] = v.propType;
  }

  if (v.default || typeof v.default !== "undefined") {
    defaultProps[k] = v.default;
  }

  return false;
});
LatticeGrid.propTypes = Object.assign({}, propTypes);
LatticeGrid.defaultProps = Object.assign({}, defaultProps);
LatticeGrid.displayName = "LatticeGrid";
var _default = LatticeGrid;
exports.default = _default;